import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import {
  ApplicantsMajorsDto,
  ApplicationTypeDto,
} from "../../types/Applicant/ApplicationTypeDto";
import { AdminApplicationsAPI } from "../../API/Admin/AdminApplicationsAPI";
import AdminHeader from "../../Admin/views/adminheader/AdminHeader";
import Cookies from "js-cookie";

const AdminApplications = () => {
  const [applications, setApplications] = useState<ApplicationTypeDto[]>([]);
  const [applicationType, setApplicationType] = useState<ApplicationTypeDto>();
  const [majors, setMajors] = useState<ApplicantsMajorsDto[]>([]);

  const fetchData = async () => {
    const semester = Cookies.get("semester");
    if (semester != null) {
      const applications = new AdminApplicationsAPI();
      setApplications(
        (await applications.GetAll(Number.parseInt(semester))).result
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleApplicationChange = async (id: number, newValue: boolean) => {
    const application = new AdminApplicationsAPI();
    await application.UpdateApplication({
      id: id,
      isOpen: newValue,
    });

    const updated = applications.map((app) =>
      app.id === id ? { ...app, isOpen: newValue } : app
    );
    setApplications(updated);
  };

  const handleMajorChange = async (id: number, newValue: boolean) => {
    const major = new AdminApplicationsAPI();
    await major.UpdateMajor({
      id: id,
      isOpen: newValue,
    });

    const updated = majors.map((app) =>
      app.id === id ? { ...app, isActive: newValue } : app
    );
    setMajors(updated);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = async (app: ApplicationTypeDto) => {
    setApplicationType(app);
    const applications = new AdminApplicationsAPI();
    setMajors((await applications.GetAllMajors(app.id)).result);
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onTypeChangeHandler = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    await fetchData();
  };

  const groupedMajors = majors.reduce((groups, major) => {
    const key = major.name || "Other";
    if (!groups[key]) groups[key] = [];
    groups[key].push(major);
    return groups;
  }, {} as Record<string, typeof majors>);

  return (
    <div className="p-4 space-y-4">
      <AdminHeader
        onTypeHandler={onTypeChangeHandler}
        semesterHandler={onTypeChangeHandler}
        title="List of applications"
        hide={true}
      />
      {applications.map((app) => (
        <div key={app.id} className="grid grid--3--cols">
          <Form>
            <Form.Check
              type="switch"
              id={app.id.toString()}
              label={app.name}
              checked={app.isOpen}
              onChange={(e) =>
                handleApplicationChange(app.id, e.target.checked)
              }
            />
          </Form>
          <span>
            {app.amount} {app.currencyName}
          </span>
          <button onClick={() => handleOpenModal(app)}>
            {app.abbr} majors
          </button>
        </div>
      ))}

      <Modal show={openModal} onHide={handleCloseModal} closeButton size="xl">
        <Modal.Header>
          {applicationType?.name}/{applicationType?.abbr}
        </Modal.Header>
        <Modal.Body>
          {Object.entries(groupedMajors).map(([stream, group]) => (
            <div key={stream} className="mb-6">
              <h3 className="text-lg font-semibold mb-2">{stream}</h3>
              <div className="space-y-2">
                {group.map((major) => (
                  <div key={major.id} className="grid grid--3--cols">
                    <Form>
                      <Form.Check
                        type="switch"
                        id={major.id.toString()}
                        label={major.tawjihiStream}
                        checked={major.isActive}
                        onChange={(e) =>
                          handleMajorChange(major.id, e.target.checked)
                        }
                      />
                    </Form>
                    <span>{major.minGrade}</span>
                    <span>
                      {major.tuition} {major.currency}
                    </span>
                  </div>
                ))}
                <hr />
              </div>
            </div>
          ))}

          {/* {majors.map((major) => (
            <div key={major.id} className="grid grid--4--cols">
              <Form style={{ width: 500 }}>
                <Form.Check
                  type="switch"
                  id={major.id.toString()}
                  label={major.name}
                  checked={major.isActive}
                  onChange={(e) =>
                    handleMajorChange(major.id, e.target.checked)
                  }
                />
              </Form>
              <span>{major.tawjihiStream}</span>
              <span>{major.minGrade}</span>
              <span>
                {major.tuition} {major.currency}
              </span>
            </div>
          ))} */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AdminApplications;
